import React, { memo } from "react"
import PropTypes from "prop-types"
import ArrowUp from "@common/ArrowUp/ArrowUp"
import ConsentBanner from "@common/ConsentBanner"
import { MobileFilterMenu } from "../../../BW-Blog/components"
import { useLayoutConfiguration } from "./hooks"
import { BlackAndWhiteLayoutContext } from "./Context"
import ConsentContextProvider from "../../../../contexts/ConsentContext"
import {
  Header,
  Footer,
  SecondCatchUpSection,
} from "./components"
import { 
  SECOND_CATCH_UP_SECTION_CONTACT_US_BUTTON_TEXT, 
  SECOND_CATCH_UP_SECTION_DESCRIPTION, 
  SECOND_CATCH_UP_SECTION_TITLE,
  ARROW_UP_BACKGROUND_COLOR
} from "./constants"
import {
  StyledBlackWhiteLayoutWrapper,
  StyledBlackWhiteContainer,
} from "./styled"

const BlackAndWhiteLayout = ({ children, path, hasCatchupSection }) => {
  const {
    isDelayed,
    isMounted,
    openMobileFilters,
    isOpenMobileBlogFilters,
    articleCategories,
    showLinks,
    headerTitle,
    selectedFilterOption,
    userToken,
    setSelectedFilterOption,
    setArticleCategories,
    setShowLinks,
    setOpenMobileFilters,
    setUserToken,
    setHeaderTitle,
    handleClick,
    openMobileFiltersSection,
    closeMobileFilters
  } = useLayoutConfiguration()

  return (
    isMounted && (
      <ConsentContextProvider>
      <BlackAndWhiteLayoutContext.Provider
        value={{
          setHeaderTitle,
          openMobileFilters,
          articleCategories,
          setOpenMobileFilters,
          isOpenMobileBlogFilters,
          openMobileFiltersSection,
          selectedFilterOption,
          setSelectedFilterOption,
          setArticleCategories,
          closeMobileFilters
        }}
      >
        <StyledBlackWhiteLayoutWrapper
          showLinks={showLinks}
        >
          {isOpenMobileBlogFilters && <MobileFilterMenu />}
          <Header
            headerTitle={headerTitle}
            handleClick={handleClick}
            openMobileFilters={openMobileFilters}
            setOpenMobileFilters={setOpenMobileFilters}
            path={path}
            setShowLinks={setShowLinks}
            showLinks={showLinks}
          />
          <StyledBlackWhiteContainer>
            {children}
            <ArrowUp backgroundColor={ARROW_UP_BACKGROUND_COLOR} />
          </StyledBlackWhiteContainer>
          {(hasCatchupSection && isDelayed) && (
            <SecondCatchUpSection
              title={SECOND_CATCH_UP_SECTION_TITLE}
              description={SECOND_CATCH_UP_SECTION_DESCRIPTION}
              buttonText={SECOND_CATCH_UP_SECTION_CONTACT_US_BUTTON_TEXT}
            />
          )}
          {isDelayed &&  <Footer />}
          <ConsentBanner />
        </StyledBlackWhiteLayoutWrapper>
      </BlackAndWhiteLayoutContext.Provider>
      </ConsentContextProvider>
    )
  )
}

BlackAndWhiteLayout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default memo(BlackAndWhiteLayout)
